module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-HO.33838c3f.png";